import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNaN from 'lodash/isNaN';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import toString from 'lodash/toString';
import repeat from 'lodash/repeat';
import { LOG_TYPE } from '../const/logger.const';
import { logger } from '../logger/logger.class';
/**
 * Formats a number into a string with thousand separator  1000000 => 1 000 000 (default)
 * @param value string or number
 * @param delimiter (optional), string 1000000 => 1.000.000, 1000000 => 1,000,000
 * @returns string | number
 *
 * Corresponding Vue filter: `formatThousands`
 */
export function formatThousands(value, delimiter = ' ') {
    if (isString(value) && isEmpty(value)) {
        logger.message('No/incorrect value provided', LOG_TYPE.error);
        return '';
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
}
/**
 * Prepends a single digit number with 0 to form a double character string number `0` => 00, `1` => 01
 * while only stringifying two digit numbers
 * For more than 2 digit number it returns the value intact
 * @param value { number }
 * @returns { string | number }
 */
export function formatTwoDigits(value) {
    const isInvalidNumber = value < 0 || isArray(value) || isObject(value) || isNaN(value);
    if (isInvalidNumber) {
        logger.message('No/incorrect value provided', LOG_TYPE.error);
        return '';
    }
    const stringValue = value.toString();
    if (stringValue.length > 2) {
        logger.message('More than 2 digits, return the same value', LOG_TYPE.info);
        return value;
    }
    const isSingleDigit = stringValue.length === 1;
    return isSingleDigit ? `0${value}` : stringValue;
}
/**
 * Turns passed argument into a masked card number
 * @param card value to format as a masked card number
 * @param lenght lenght of an unmasked, shown value, no more than 4
 * @returns string
 */
export function maskCardNumber(card, lenght = 4) {
    const maxLength = lenght > 4 ? 4 : lenght;
    const cardNumber = maxLength ? toString(card).slice(-maxLength) : '';
    const additionalStars = cardNumber.length > 4 ? 0 : 4 - cardNumber.length;
    return `**** **** **** ${repeat('*', additionalStars)}${cardNumber}`;
}
/**
 * Turns passed argument into a masked iban number
 * @param iban value to format as a masked iban number
 * @param initialLength lenght of the initial part unmasked
 * @param finalLength lenght of the final part unmasked
 * @returns string
 */
export function maskIbanNumber(iban, initialLength = 4, finalLength = 4) {
    const ibanTrimmed = toString(iban).replace(/\s/g, '');
    const ibanPattern = new RegExp(`^(.{${initialLength}})(.*)(.{${finalLength}})$`);
    const ibanMasked = '*'.repeat(Math.max(0, ibanTrimmed.length - initialLength - finalLength));
    return ibanTrimmed.replace(ibanPattern, `$1${ibanMasked}$3`);
}
